function errorRecovery() {
    const recovery = document.querySelector('[data-error-recovery]');
    if (!recovery) return;

    const records = {
        en: {
            message: 'This page could not be loaded. Return to Work or try again.',
            retryLabel: 'Try again',
            workLabel: 'Work',
            workUrl: '/work/'
        },
        de: {
            message: 'Diese Seite konnte nicht geladen werden. Kehren Sie zu Projekte zurück oder versuchen Sie es erneut.',
            retryLabel: 'Erneut versuchen',
            workLabel: 'Projekte',
            workUrl: '/de/arbeit/'
        }
    };
    const locale = window.location.pathname.startsWith('/de/') ? 'de' : 'en';
    const record = records[locale];
    const message = recovery.querySelector('[data-error-message]');
    const retry = recovery.querySelector('[data-error-retry]');
    const work = recovery.querySelector('[data-error-work]');

    if (!message || !retry || !work) return;

    message.textContent = record.message;
    work.textContent = record.workLabel;
    work.setAttribute('href', record.workUrl);
    retry.textContent = record.retryLabel;
    retry.addEventListener('click', function () {
        window.location.reload();
    });
}
